import styled from 'vue-styled-components';
import { FONTS } from '../../constants';
import { COLORS } from '../../colors';

export const SourceContainer = styled.div`
  width: 100%;
  font-size: 16px;
  font-family: ${FONTS.KNOCKOUT_32_FONT};
  word-break: break-word;
  line-height: 1.5;
  color: ${COLORS.MAKO};
`;
